import { Box } from "@mui/material";
import { styled } from "@mui/system";

export const Root = styled(Box)`
  width: 100%;
`;
